/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { MenuIconName } from './menu-icon-name';
import { MenuItemUiModuleBody } from './menu-item-ui-module-body';
import { MenuType } from './menu-type';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface MenuSectionUiModuleBody
 */
export interface MenuSectionUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof MenuSectionUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuSectionUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuSectionUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuSectionUiModuleBody
     */
    moduleType: MenuSectionUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof MenuSectionUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof MenuSectionUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof MenuSectionUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof MenuSectionUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof MenuSectionUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof MenuSectionUiModuleBody
     */
    titleLokaliseKey?: string;
    /**
     * 
     * @type {MenuIconName}
     * @memberof MenuSectionUiModuleBody
     */
    iconName?: MenuIconName;
    /**
     * 
     * @type {Array<MenuItemUiModuleBody>}
     * @memberof MenuSectionUiModuleBody
     */
    menuItems: Array<MenuItemUiModuleBody>;
    /**
     * 
     * @type {string}
     * @memberof MenuSectionUiModuleBody
     */
    targetId?: string;
    /**
     * 
     * @type {MenuType}
     * @memberof MenuSectionUiModuleBody
     */
    type?: MenuType;
}

/**
    * @export
    * @enum {string}
    */
export enum MenuSectionUiModuleBodyModuleTypeEnum {
    MENU_SECTION = 'MENU_SECTION'
}



